import { Text } from '@fluentui/react';
import React from 'react';
import { IGridStyle, TABLE_HEAD_STYLE, TABLE_STYLE } from './PharmacyPlan.constants';

interface IPharmacyCompareTableProps {
    className: string;
    tableStyles: IGridStyle;
    children: React.ReactNode;
    originHeader?: string;
    targetHeader: string;
    actionHeader?: string;
    hideActionHeader?: boolean;
    hideTargetHeader?: boolean;
    hideOriginHeader?: boolean;
}

const CompareTable: React.FC<IPharmacyCompareTableProps> = React.memo((props) => {
    return (
        <table style={TABLE_STYLE}>
            <thead style={TABLE_HEAD_STYLE}>
                <tr>
                    <th style={props.tableStyles.theadColName}>
                        <Text styles={props.tableStyles.headerStyles}>
                            Attribute
                        </Text>
                    </th>
                    {!props.hideOriginHeader && (
                        <th style={props.tableStyles.theadColOrigin}>
                            {props.originHeader &&
                                <Text styles={props.tableStyles.headerStyles}>
                                    {props.originHeader}
                                </Text>
                            }
                        </th>
                    )}
                    {!props.hideTargetHeader && (
                        <th style={props.tableStyles.theadColTarget}>
                            <Text styles={props.tableStyles.headerStyles}>
                                {props.targetHeader}
                            </Text>
                        </th>
                    )}
                    {(!props.hideActionHeader) && (
                        <th style={props.tableStyles.theadColAction}>
                            <Text styles={props.tableStyles.headerStyles}>
                                {props.actionHeader}
                            </Text>
                        </th>
                    )}
                </tr>
            </thead>
            <tbody className={props.className}>
                {props.children}
            </tbody>
        </table>
    );
});

export default CompareTable;